<template>
    <div class="create-page">
        <TopNav />

        <!-- 嵌套路由的出口 -->
        <div class="create-container">
            <!-- 左侧菜单组件 -->
            <aside class="create-sidebar">
                <div class="sidebar-header">
                    <h3>{{ $t('AiLayout.AI创作中心') }}</h3>
                </div>
                <nav class="sidebar-nav">
                    <div class="nav-group">
                        <div class="nav-title">
                            <i class="el-icon-video-camera" /> {{ $t('AiLayout.视频生成') }}
                        </div>
                        <div v-for="item in videoMenus" :key="item.path" class="nav-btn"
                            :class="{ active: isActive(item.path) }" @click="handleTab(item.path)">
                            <i :class="item.icon" />
                            <span>{{ $t(item.label) }}</span>
                        </div>
                    </div>
                    <div class="nav-group">
                        <div class="nav-title">
                            <i class="el-icon-picture" /> {{ $t('AiLayout.图片生成') }}
                        </div>
                        <div v-for="item in imageMenus" :key="item.path" class="nav-btn"
                            :class="{ active: isActive(item.path) }" @click="handleTab(item.path)">
                            <i :class="item.icon" />
                            <span>{{ $t(item.label) }}</span>
                        </div>
                    </div>
                    <div class="nav-group">
                        <div class="nav-title">
                            <i class="el-icon-folder-opened" /> {{ $t('AiLayout.我的作品') }}
                        </div>
                        <div class="nav-btn" :class="{ active: isActive('/ai/my-creation') }"
                            @click="handleTab('/ai/my-creation')">
                            <i class="el-icon-folder-opened" />
                            <span>{{ $t('AiLayout.我的创作') }}</span>
                        </div>
                    </div>
                </nav>

                <!-- 底部提示 -->
                <div class="sidebar-footer">
                    <div class="tip-card">
                        <i class="el-icon-info" />
                        <div class="tip-content">
                            <p>{{ $t('Other.剩余额度') }}</p>
                            <span class="tip-value" v-if="userInfo && userInfo.credit">{{ userInfo.credit * 1 }}</span>
                            <span class="tip-value" style="cursor: pointer;" v-else @click="handleTab('/login')">
                                {{ $t('Other.去登录') }}
                            </span>
                        </div>
                    </div>
                </div>
            </aside>

            <!-- 右侧内容区 -->
            <main class="create-main">
                <router-view />
            </main>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import TopNav from '@/components/TopNav.vue'

export default {
    name: 'AiLayout',
    components: {
        TopNav
    },
    data() {
        return {
            videoMenus: [
                { path: '/ai/reference', label: 'AiLayout.多参考', icon: 'el-icon-film' },
                { path: '/ai', label: 'AiLayout.文本视频', icon: 'el-icon-edit-outline' },
                { path: '/ai/image-to-video', label: 'AiLayout.图片视频', icon: 'el-icon-picture-outline' }
            ],
            imageMenus: [
                { path: '/ai/text-to-image', label: 'AiLayout.文生图', icon: 'el-icon-brush' },
                { path: '/ai/image-to-image', label: 'AiLayout.图生图', icon: 'el-icon-camera' }
            ],
            activeTab: ''
        }
    },
    watch: {
        '$route.path': {
            handler(newPath) {
                this.activeTab = newPath
            },
            immediate: true
        }
    },
    computed: {
        ...mapState(['userInfo']),
    },
    mounted() {
        this.activeTab = this.$route.path
    },
    methods: {
        isActive(path) {
            const currentPath = this.$route.path
            return currentPath === path
        },
        handleTab(path) {
            if (this.$route.path !== path) {
                this.$router.push(path)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.create-page {
    background: #08080f;
    color: #f1f5f9;
    min-height: 100vh;
    padding-top: 72px;

    .create-container {
        display: flex;
        max-width: 1400px;
        margin: 0 auto;
        min-height: calc(100vh - 72px);
    }

    .create-main {
        flex: 1;
        margin-left: 280px;
        padding: 2rem;
    }
}

.create-sidebar {
    width: 280px;
    background: rgba(15, 15, 26, 0.8);
    backdrop-filter: blur(10px);
    border-right: 1px solid rgba(255, 255, 255, 0.08);
    padding: 1.5rem;
    position: fixed;
    left: 0;
    top: 72px;
    bottom: 0;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 3px;

        &:hover {
            background: rgba(255, 255, 255, 0.3);
        }
    }

    .sidebar-header {
        margin-bottom: 2rem;
        padding-bottom: 1rem;
        border-bottom: 1px solid rgba(255, 255, 255, 0.08);

        h3 {
            font-size: 1.25rem;
            font-weight: 700;
            background: linear-gradient(135deg, #6366f1, #a855f7);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            display: flex;
            align-items: center;
            gap: 0.5rem;
        }
    }

    .sidebar-nav {
        flex: 1;

        .nav-group {
            margin-bottom: 1.5rem;

            .nav-title {
                font-size: 0.75rem;
                color: #64748b;
                text-transform: uppercase;
                letter-spacing: 0.5px;
                margin-bottom: 0.75rem;
                padding-left: 0.75rem;
                display: flex;
                align-items: center;
                gap: 0.5rem;

                i {
                    font-size: 0.75rem;
                }
            }

            .nav-btn {
                width: 100%;
                display: flex;
                align-items: center;
                gap: 0.75rem;
                padding: 0.75rem 1rem;
                background: transparent;
                border: none;
                border-radius: 12px;
                color: #94a3b8;
                font-size: 0.9375rem;
                cursor: pointer;
                margin-bottom: 0.5rem;

                &:hover {
                    background: rgba(255, 255, 255, 0.05);
                    color: #f1f5f9;
                    transform: translateX(4px);
                }

                &.active {
                    background: linear-gradient(135deg, rgba(99, 102, 241, 0.2), rgba(168, 85, 247, 0.2));
                    color: #f1f5f9;
                    border: 1px solid rgba(99, 102, 241, 0.3);
                    position: relative;

                    &::before {
                        content: '';
                        position: absolute;
                        left: -1.5rem;
                        top: 50%;
                        transform: translateY(-50%);
                        width: 3px;
                        height: 20px;
                        background: linear-gradient(135deg, #6366f1, #a855f7);
                        border-radius: 0 3px 3px 0;
                    }
                }

                i {
                    width: 20px;
                    text-align: center;
                    font-size: 1rem;
                }
            }
        }
    }

    .sidebar-footer {
        margin-top: 2rem;
        padding-top: 1rem;
        border-top: 1px solid rgba(255, 255, 255, 0.08);

        .tip-card {
            background: linear-gradient(135deg, rgba(99, 102, 241, 0.1), rgba(168, 85, 247, 0.05));
            border: 1px solid rgba(99, 102, 241, 0.2);
            border-radius: 12px;
            padding: 1rem;
            display: flex;
            align-items: center;
            gap: 0.75rem;

            i {
                font-size: 1.5rem;
                color: #818cf8;
            }

            .tip-content {
                flex: 1;

                p {
                    font-size: 0.75rem;
                    color: #64748b;
                    margin-bottom: 0.25rem;
                }

                .tip-value {
                    font-size: 1.25rem;
                    font-weight: 700;
                    color: #fbbf24;
                }
            }
        }
    }
}

// 响应式
@media (max-width: 1024px) {
    .create-sidebar {
        width: 240px;
    }

    .create-page .create-main {
        margin-left: 240px;
    }
}

@media (max-width: 768px) {
    .create-sidebar {
        display: none;
    }

    .create-page .create-main {
        margin-left: 0;
        padding: 1rem;
    }
}

@media (max-width: 480px) {
    .create-page {
        padding-top: 60px;
    }
}
</style>